<template>
    <div class="external-activity--card" @click="moveForward(contentItem)" :style="`border-radius: ${activity.card_border_radius}px`">
        <div class="external-activity--card-image" v-if="contentItem.media.length > 0">
            <ActivityExternalSwiper :media="contentItem.media" :id="contentItem.id"/>
        </div>
        <div class="external-activity--card-content external-activity--card-flex">
            <div class="info-container">
                <h4>{{ findValueFromCode(contentItem, 'title', language, defaultLanguage, false) }}</h4>
                <p v-html="findValueFromCode(contentItem, 'description', language, defaultLanguage, true)"></p>
                <!-- <Tags :tags="contentItem.tags" :languageId="language.id"/> -->
                <template v-if="contentItem.restaurant && contentItem.restaurant.content_id == contentItem.id">
                    <div v-if="contentItem.restaurant.opening_status.open"
                        style="font-size: 12px; margin-top: 10px;"
                        class="text-success">
                        {{ defaultCartLanguage.restaurant_closes }} {{ defaultCartLanguage.restaurant_at }} {{ contentItem.restaurant.opening_status.time }}
                    </div>
                    <div v-else
                        style="font-size: 12px; margin-top: 10px;"
                        class="text-danger">
                        {{ defaultCartLanguage.restaurant_opens }}
                        {{ defaultCartLanguage.days[contentItem.restaurant.opening_status.day] }} {{ defaultCartLanguage.restaurant_at }} {{ contentItem.restaurant.opening_status.time }}
                    </div>
                </template>
            </div>
            <div class="button-next" v-if="contentItem.children.length > 0"><a href="#" @click="moveForward(contentItem)"><i class="fal fa-arrow-right" aria-hidden="true"></i></a></div>
        </div>
    </div>
</template>
<script>
    import Tags from './Tags'
    import ActivityExternalSwiper from '../ActivityExternalSwiper'
    export default {
        props: [
            'activity',
            'defaultCartLanguage',
            'contentItem',
            'moveForward',
            'findValueFromCode',
            'language',
            'defaultLanguage'
        ],

        components: {
            ActivityExternalSwiper,
            Tags,
        }
    }
</script>
